import { envManager, env } from '@accor/customer-core/env'
import { getTokenErrorHandler } from '@/services/getTokenErrorHandler'
import { AdsLink } from '@accor/ads-components'
import { configure as customerLibConfigure } from '@accor/customer-lib'
import { i18nService } from '@accor/customer-vue-services'
import { isWebView } from '@accor/customer-core'
import prodConfig from '../../config/config-pro.json'

export const configureEnv = async () => {
  await envManager.configure(
    'all.accor.com',
    {
      ...prodConfig,
      isOneTrustEnabled: !isWebView(),
      // Prevent RUM in E2E tests
      // @ts-expect-error - false is a valid disable sentinel at runtime (envManager does a truthy check),
      // but @accor/customer-core@5.1's SplunkRUMConfiguration type doesn't declare boolean in the union
      splunkRUM: window.location.hostname !== 'localhost' ? prodConfig.splunkRUM : false
    },
    {
      i18nService,
      // getTokenErrorHandler reequired for the moment to avoid unhandled exception.
      // need to update customer-common-front to use onGetTokenError of customer-lib like getToken and only then we can remove it.
      getTokenErrorHandler,
      linkComponent: AdsLink,
      getAppVersion: () => __APP_VERSION__,
      basePath: 'account'
    },
    `${import.meta.env.BASE_URL}config.json`
  )

  customerLibConfigure({
    client: 'customer-account',
    apiKey: env.config.apiKey,
    apiAccorCom: env.config.apiAccorComApi,
    allAccorCom: env.config.allAccorComOrigin,
    loginAccorCom: env.config.pingApiUrl,
    onGetTokenError: getTokenErrorHandler
  })
}
